// extracted by mini-css-extract-plugin
module.exports = {"component":"menu-navigation_component_OM8-5","button":"menu-navigation_button_1AsrX"};